<app-table [configurationTable]="configurationTable"></app-table>
